module.exports = __webpack_public_path__ + "img/left.c8a9163e.svg";